// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2v8o7","requiredAsterisk":"Info_requiredAsterisk__leGgY"};